var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6757 19.4916C16.2201 19.036 16.2201 18.2973 16.6757 17.8417C17.1313 17.3861 17.87 17.3861 18.3256 17.8417L22.9923 22.5084C23.4479 22.964 23.4479 23.7027 22.9923 24.1583C22.5367 24.6139 21.798 24.6139 21.3424 24.1583L16.6757 19.4916Z",
    fill: "#2E2360"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66602 12.8327C4.66602 17.343 8.32236 20.9993 12.8327 20.9993C17.343 20.9993 20.9993 17.343 20.9993 12.8327C20.9993 8.32236 17.343 4.66602 12.8327 4.66602C8.32236 4.66602 4.66602 8.32236 4.66602 12.8327ZM18.6667 12.8333C18.6667 16.055 16.055 18.6667 12.8333 18.6667C9.61167 18.6667 7 16.055 7 12.8333C7 9.61167 9.61167 7 12.8333 7C16.055 7 18.6667 9.61167 18.6667 12.8333Z",
    fill: "#2E2360"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.23eae5014d2ebcb552370aea6cb4fb96.svg";
export { ForwardRef as ReactComponent };